import React, { FC } from 'react';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import { CandidateProfileDataItemProps } from './props';
import './styles.scss';

export const CandidateProfileDataItem: FC<CandidateProfileDataItemProps> = ({
  className,
  icon,
  iconElem,
  label,
  data,
}) => {
  return (
    <div className={classnames('candidate-profile-data-item', className)}>
      {iconElem || <Svg src={icon} />}

      <div className="candidate-profile-data-item__wrapper">
        <div className="candidate-profile-data-item__info">{label}</div>

        <div className="candidate-profile-data-item__data">{data}</div>
      </div>
    </div>
  );
};
